export default __webpack_public_path__ + "static/media/57.952fcc13.jpg";